module.exports = __webpack_public_path__ + "static/img/paat1920.d22f4ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/home/banner/paat1920.jpg
// module id = VBwe
// module chunks = 51